module.exports = __webpack_public_path__ + "static/media/Coursera_logo.23ec484f.svg";